import React from "react";
import styled from "styled-components";
import { darken, rgba } from "polished";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DocumentType } from "../../../types/DocumentType";

const WarningBox = styled.div`
    background: ${(props: any) => darken(0.5, rgba(props.theme.warning, 0.5))};
`;

export const DocumentDeleteMessage = ({ document } : Readonly<{ document: DocumentType }>) : JSX.Element => (
    <div>
        <WarningBox className="d-flex border border-warning rounded-1 mb-3 p-3">
            <div className="me-3 mt-3 text-warning">
                <FontAwesomeIcon icon={['fas', 'triangle-exclamation']} size="2x" />
            </div>
            <p className="text-white">
                <span className="fw-bold">This Document will be removed</span>
                <br/>
                <span>This action will remove the record from our database. You will have 30 days to recover this document before it is permanently removed from the cloud.</span>
            </p>
        </WarningBox>
        <p className="mt-3">Are you sure you want to delete the document '{document.fileName}'?</p>
    </div>
);